import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    support: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for support button that opens Intercom or Jarvis */
            support: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AlertBannerSupportButton.support?c=34pi99qpzzbpq", defaultMessage: "Support" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
